export const MERCHANT_ROLES = ['merchant', 'merchant-finance', 'merchant-support', 'accountant-finance', 'auditor-finance', 'api-finance', 'merchant-authorizer'];
export const CASHPOINT_ROLES = ['cashier'];
